import React from "react";
import ServiceCard from "./ServiceCard";
import Image1 from "../../images/services/Abu Dhabi Airport.jpeg";
import Image2 from "../../images/services/RAK-Airport.jpg";
import Image3 from "../../images/services/SHARJAH Airport.jpeg";
import Image4 from "../../images/services/dubai-airport.png";
import Image5 from "../../images/services/dubai-city.png";
import Image6 from "../../images/services/ras-al-khaimah-sightseeing.jpg";

const Service = () => {
  const services = [
    {
      name: "Dubai Airport Transfers ",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image1,
    },
    {
      name: "Ras Al Khaima Airport Transfers",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image2,
    },
    {
      name: "SHARJAH Airport Transfers",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image3,
    },
    {
      name: "Abu Dhabi Airport Transfers ",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image4,
    },
    {
      name: "Dubai City Tour ",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image5,
    },
    {
      name: "Ras Al Khaima Tour",
      description:
        "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
      passengers: "4-7 Passengers",
      bags: "1-3 Bags",
      duration: "3 Hours",
      image: Image6,
    },
    // {
    //   name: "Abu Dhabi Tour",
    //   description:
    //     "Explore the lively and diverse city of Dubai with our day tour that offers a glimpse into its modern marvels and rich traditions. Discover iconic landmarks like the Burj Khalifa, the world’s tallest building, and the opulent Burj Al Arab hotel. Bask in the luxury of the Palm Jumeirah, home to renowned resorts such as Atlantis and The Palm.",
    //   passengers: "4-7 Passengers",
    //   bags: "1-3 Bags",
    //   duration: "3 Hours",
    //   image:
    //     "https://platina-chauffeurs.ae/wp-content/uploads/2024/02/4-768x531.jpg",
    // },
  ];

  return (
    <section className='choose-section'>
      <div className='container'>
        <div className='pick-container'>
          <div className='pick-container__title'>
            <h3>Vehicle Models</h3>
            <h2>Our Services</h2>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10'>
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
